import axios from 'axios';
import store from './store';

axios.defaults.baseURL = process.env.VUE_APP_SERVER;
let token = store.state.user.token;
axios.defaults.headers.common['Authorization'] = `Bearer ${token}` ;
axios.defaults.headers.common['Accept'] = 'application/json';
